export const DEFAULT_PAGE_SIZE = 10;
const initialState = {
  data: [],
  pages: 0,
  totalElements: 0,
  loading: false,
  isError: false,
  listState: {
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    sorted: [{ id: "name", desc: false }],
    filtered: [],
  },
};

export function Reducer(previousState = initialState, action) {
  switch (action.type) {
    case 'UPDATE_CUSTOMER_LIST_SUCCESS':
      return {
        ...previousState,
        data: action.payload.records.map(record => ({
          ...record,
          createdBy: record.createdById,
        })),
        pages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
        loading: false,
        isError: false,
        listState: {
          ...previousState.listState,
          page: action.payload.page
        }
      };
    case 'UPDATE_CUSTOMER_LIST_REQUEST':
      return {
        ...previousState,
        listState: action.payload.listState,
        totalElements: "Loading ...",
        loading: true,
        isError: false
      };
    case 'UPDATE_CUSTOMER_INDEX_ON_LIST':
      return {
        ...previousState,
        indexOnList: action.indexOnList
      };
    case 'UPDATE_CUSTOMER_LIST_FAILURE':
      return {
        ...previousState,
        data: undefined,
        pages: 0,
        totalElements: 0,
        loading: false,
        isError: true
      };
    case 'RESET_ERROR_MESSAGE_CUSTOMER_LIST':
      return {
        ...previousState,
        isError: false
      };
    default:
      return previousState;
  }
}